exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/browserify-aes/modes/ecb.js
// module id = ../../../../browserify-aes/modes/ecb.js
// module chunks = 4